(function() { window.GUID_733ec661_671b_4827_b64b_1fc5f99c14e1 = { getGuid: function() { return "733ec661-671b-4827-b64b-1fc5f99c14e1"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PremiumFeature;
        (function (PremiumFeature) {
            PremiumFeature[PremiumFeature["Generic"] = 0] = "Generic";
            PremiumFeature[PremiumFeature["StatsCompare"] = 1] = "StatsCompare";
            PremiumFeature[PremiumFeature["StatsGraph"] = 2] = "StatsGraph";
        })(PremiumFeature = Enumeration.PremiumFeature || (Enumeration.PremiumFeature = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PremiumFeature.pre.js.map
